












































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import LeftNavigationComponent from "@/components/App/Modules/GMS/Workspace/Components/LeftNavigation.vue";
import AutoCompleteForm from "./AutoCompleteForm.vue";
import TechnicalReportingPeriod from "./Grant/TechReportingPeriod.vue";
import FinancialReportingPeriod from "./Grant/FinancialReportingPeriod.vue";
import DocumentForm from "./DocumentForm.vue";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import { MigrationImport } from "@/entities";
import NavigationButtons from "@/components/App/Modules/GMS/Workspace/Components/NavigationButtons.vue";
import { http as _http } from "@/shared/https";
import { Locales } from "@/i18n/locales";

const namespace: string = "migration";

@Component({
  components: {
    VJsonschemaForm,
    AutoCompleteForm,
    LeftNavigationComponent,
    DocumentForm,
    NavigationButtons,
    TechnicalReportingPeriod,
    FinancialReportingPeriod,
  },
})
export default class GenericImportFormComponent extends Vue {
  @Action("showNotification", { namespace: "application" }) notify: any;
  @State(namespace) migration!: MigrationImport;

  @Prop() schema!: any;
  @Prop() grantSchema!: any;
  @Prop() users!: any;
  @Prop() tags!: any;
  @Prop() appData!: any;
  @Prop() subKey!: any;
  @Prop() rootSchema: any;
  @Prop() isDirty!: boolean;
  @Prop() selectedTopMenu!: string;

  showSideBar = true;
  componentKey = 0;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  get options() {
    return {
      httpLib: _http,
      baseURI: process.env.VUE_APP_API_Base_URL,
      currency: this.migration.Currency,
      locale: this.defaultLocale
    };
  }

  change(e) {}

  subMenuChanged(selectedMenu, key) {
    this.$emit("subMenuChanged", key);
  }

  get subSchema() {
    if (this.subKey) {
      return this.schema.properties[this.subKey];
    } else {
      return this.subSchema;
    }
  }

  sidebarToggle() {
    this.showSideBar = !this.showSideBar;
  }

  showInput(e) {
    this.$emit("input", true);

    if (
      e.key == "grantAgreementDate" &&
      e.model &&
      this.appData["projectStartDate"] &&
      Date.parse(e.model) > Date.parse(this.appData["projectStartDate"])
    ) {
      this.notify({
        text: this.$t(
          "Attention: The date entered is posterior to the start date of the project"
        ),
        isHtml: true,
        color: "info",
      });
    }
  }
}
